export enum ImageRatio {
    '16/9' = 16 / 9,
    '4/3' = 4 / 3,
    '3/2' = 3 / 2,
    '1/1' = 1,
}
